import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Popover
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { SketchPicker } from 'react-color';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { saveBuffer, updateBuffer } from "../../Services/GeometryUserService";
import { db } from '../../db';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      displayColorPicker: false,

      data: {
        id: '',
				name: '',
				type: '',
				user: '',
				cidade: null,
				estado: null,
				substancia: null,
				substanciaUso: null,
				description: '',
				cidadeDivisa: '',
				color: '#87CEFA',
        colorRGB: {r: 135, g: 206, b: 250, a: 1},
				status: "ATIVO",
				deleted: false,
				createdAt: '',
        updatedAt: '',
        syncAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      let rgb = JSON.stringify(data['colorRGB']);
      data['colorRGB'] = rgb;

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      let request = {
        dataUserGeometryList: []
      };
      request.dataUserGeometryList.push(data);
  
      if(data.id === undefined || data.id === null || data.id === ''){
        saveBuffer(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              db.remove(data.name, "BUFFER");
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }else{
        updateBuffer(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              db.remove(data.name, "BUFFER");
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;
    
    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    return validated;  
  }

  loadData(selected) {
    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        if(selected.id === null){
          selected.id = '';
        }
        if(selected.user === null){
          selected.user = '';
        }
        if(selected.description === null){
          selected.description = '';
        }
        if(selected.cidadeDivisa === null){
          selected.cidadeDivisa = '';
        }

        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected } = this.props;
    this.loadData(selected);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected){
      this.loadData(this.props.selected);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['type'] = '';
    data['user'] = '';
    data['cidade'] = null;
    data['estado'] = null;
    data['substancia'] = null;
    data['substanciaUso'] = null;
    data['description'] = '';
    data['cidadeDivisa'] = '';
    data['color'] = '#87CEFA';
    data['colorRGB'] = {r: 135, g: 206, b: 250, a: 1};
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    data['syncAt'] = '';

    this.setState({ 
      data,
      active: false,
      displayColorPicker: false
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ displayColorPicker: !prevState.displayColorPicker, active: !prevState.active }));
  };

  handleChange = (color) => {
    const data = { ...this.state.data }
    data['color'] = color.hex;
    data['colorRGB'] = color.rgb;
    this.setState({ data });
  };

  render() {
    const { t } = this.props;
    const { data, active, displayColorPicker } = this.state;
    const color = data.color;
    const rgb = data.colorRGB;
    
    let notOK = !hasAccess("MENU_MY_BUFFER_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let cidades = [];
    let cidadeList = this.state.data.cidadeDivisa.substring(0,this.state.data.cidadeDivisa.lastIndexOf(";")).split(";");
    for(let i = 0; i < cidadeList.length; i++){
      cidades.push(<div key={"cidade_"+i}>{cidadeList[i]}</div>);
    }
    let isDivisa = false;
    if(cidades.length > 1){
      isDivisa = true;
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.localizacao')} <i style={{color: '#ff0000', fontSize: '11px'}}>{(isDivisa ? t('forms.localizacaoDivisa') : '')} </i> 
                  </span>
                  <div className="form__form-group-field" 
                    style={{borderLeft: '2px solid #ffd9d9', minHeinght: '25px', height: 'auto', 
                            display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', paddingLeft: '5px',
                            marginLeft: '5px', fontStyle: 'italic', color: '#ff0000'}}>
                    {cidades}

                  </div>
                </div>
              </div>


              <div className="form__half">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.color')} 
                  </span>
                  <div className="form__form-group-field">
                    <div className="color-picker">
                      <button
                        type="button"
                        className={`color-picker__button${active ? ' active' : ''}`}
                        onClick={this.handleClick}
                        id="color"
                      >
                        <p className="color-picker__color">{color}</p>
                        <div className="color-picker__color-view" style={{ backgroundColor: color }} />
                      </button>
                      <Popover
                        isOpen={displayColorPicker}
                        target="color"
                        placement="bottom"
                        className="color-picker__popover"
                      >
                        <SketchPicker
                          color={rgb}
                          onChange={e => this.handleChange(e)}
                        />
                      </Popover>
                    </div>                    
                  </div>
                </div>
                
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'requerimentoEdit', 
})(withTranslation('common')(CrudEdit));
